import { CRAFT_BLOCK_TYPE } from '@shared/protocol';

/** Built-in block types available in the full block library. */
export interface BlockType {
  readonly id: number;
  readonly name: string;
  /** Color as a three.js hex number. */
  readonly color: number;
  /** Same color as a CSS string (hotbar swatches). */
  readonly css: string;
}

export const BLOCK_TYPES: readonly BlockType[] = [
  { id: 1, name: 'White', color: 0xfafafa, css: '#fafafa' },
  { id: 2, name: 'Red', color: 0xd9534f, css: '#d9534f' },
  { id: 3, name: 'Orange', color: 0xf0883e, css: '#f0883e' },
  { id: 4, name: 'Yellow', color: 0xf7d154, css: '#f7d154' },
  { id: 5, name: 'Green', color: 0x58b368, css: '#58b368' },
  { id: 6, name: 'Cyan', color: 0x4ec9d6, css: '#4ec9d6' },
  { id: 7, name: 'Blue', color: 0x3a86d4, css: '#3a86d4' },
  { id: 8, name: 'Purple', color: 0x9b6bd4, css: '#9b6bd4' },
  { id: 9, name: 'Brown', color: 0x8a5a3b, css: '#8a5a3b' },
  { id: 10, name: 'Charcoal', color: 0x3b3f46, css: '#3b3f46' },
  { id: CRAFT_BLOCK_TYPE, name: 'Craft block', color: 0x2a2f36, css: '#2a2f36' },
];

export const STANDARD_BLOCK_TYPES = BLOCK_TYPES.filter(
  (type) => type.id !== CRAFT_BLOCK_TYPE,
);

const BY_ID = new Map(BLOCK_TYPES.map((t) => [t.id, t]));

export function blockTypeById(id: number): BlockType {
  const type = BY_ID.get(id);
  if (!type) throw new Error(`Unknown block type id ${id}`);
  return type;
}
